import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 缓存组件
    cacheComponents: [],
    // token
    token: "",
    sign: "",
  },
  mutations: {
    // 向缓存中添加组件
    ["ADD_COMPONENTS"](state, componentName) {
      if (state.cacheComponents.includes(componentName)) {
        return;
      }
      state.cacheComponents.push(componentName);
    },
    // 从缓存中移除组件
    ["REMOVE_COMPONENTS"](state, componentName) {
      const index = state.cacheComponents.indexOf(componentName);
      if (index === -1) {
        return;
      }
      state.cacheComponents.splice(index, 1);
    },
    // 设置token
    ["SET_TOKEN"](state, token) {
      state.token = token;
    },
    ["SET_SIGN"](state, sign) {
      state.sign = sign;
    },
  },
  actions: {},
  modules: {},
  getters: {
    userMsg: (state) => state.userMsg,
  },
});
